import { render, staticRenderFns } from "./deal-info.html?vue&type=template&id=18f47b85&scoped=true&external"
import script from "./deal-info.js?vue&type=script&lang=js&external"
export * from "./deal-info.js?vue&type=script&lang=js&external"
import style0 from "./deal-info.scss?vue&type=style&index=0&id=18f47b85&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f47b85",
  null
  
)

export default component.exports